import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { PsRoutes } from '../shared/routing/Routes';
import AttachmentSummaryScreen from './AttachmentSummaryScreen';
import AttachmentScreen from './AttachmentScreen';

export class AttachmentRouting extends React.Component {

    render() {
        const { currentUser } = this.props;

        if (
            currentUser.isAdmin() ||
            currentUser.isContractorsManager() ||
            currentUser.isOutsourcesManager()
        ) {
            return (
                <React.Fragment>
                    <Route exact path={PsRoutes.DOCUMENTS_ATTACHMENT_SUMMARY} component={AttachmentSummaryScreen}/>
                    <Route exact path={PsRoutes.DOCUMENTS_ATTACHMENT} component={AttachmentScreen}/>
                </React.Fragment>
            );
        }

        return null;
    }
}

AttachmentRouting.propTypes = {
    currentUser: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/attachment/AttachmentRouting.jsx